import { render } from "./ScNotification.vue?vue&type=template&id=2d9eb76e&scoped=true"
import script from "./ScNotification.vue?vue&type=script&lang=js"
export * from "./ScNotification.vue?vue&type=script&lang=js"

import "./ScNotification.vue?vue&type=style&index=0&id=2d9eb76e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d9eb76e"]])

export default __exports__